import { render, staticRenderFns } from "./TypographyStyleList.vue?vue&type=template&id=2afbfa66&scoped=true&"
import script from "./TypographyStyleList.vue?vue&type=script&lang=js&"
export * from "./TypographyStyleList.vue?vue&type=script&lang=js&"
import style0 from "./TypographyStyleList.vue?vue&type=style&index=0&id=2afbfa66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afbfa66",
  null
  
)

export default component.exports